import { Component, h } from 'preact';
import { FinText } from '../../../i18n';
import { Properties } from '../../../common';
import { BookingState, connectStore } from '../../../store';
import { WithStyles, withStyles } from '../../../style';
import Notification, { Severity } from '../Notification/Notification';

interface StoreProps {
  open: boolean;
}

type EffectiveProps = Properties & StoreProps & WithStyles;

const mapStateToProps = ({
  ux: {
    warnings: { routeNotSupported },
  },
}: BookingState): StoreProps => ({
  open: routeNotSupported,
});

@withStyles()
@connectStore({ mapStateToProps })
export default class RouteNotFoundNotification extends Component<Properties> {
  render({ open }: EffectiveProps): h.JSX.Element {
    return (
      <Notification open={open} severity={Severity.ERROR}>
        {<FinText id="notification.routeNotSupported" />}
      </Notification>
    );
  }
}
